import customerCenter from './customer-center';
import checklists from './checklists';
import projects, { projects2 } from './projects';
import events from './events';
import integrations from './integrations';
import user from './user';
import visualEvents from './visual-events';
import insights from './insights';
import announcements, { announcementsV2 } from './announcements';
import segments from './segments';
import stats from "src/api/stats";
import account from "src/api/account";
import surveys from 'src/api/surveys';
import onboarding from './onboarding';
import files from './files';

export default {
    customerCenter: customerCenter,
    checklists,
    files,
    projects,
    projects2,
    events,
    integrations,
    user,
    visualEvents,
    insights,
    announcements,
    announcementsV2,
    segments,
    stats,
    account,
    surveys,
    onboarding
}
